var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"0","md":"1","lg":"2"}}),_c('b-col',[_c('ai-chat')],1),_c('b-col',{attrs:{"cols":"0","md":"1","lg":"2"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }